// Requests section — sales + feedback flow pages with real card grids.

const _cardGrid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
  gap: 'A'
}

export const RequestsMain = {
  extends: 'AppMain',
  Header: { extends: 'TicketsHeader' },
  Body: {
    overflow: 'auto',
    Hero: {
      extends: 'PageHero',
      eyebrow: 'REQUESTS',
      headline: 'Customer Requests',
      lede: (el, s) => {
        const n = (s.root.customerRequests || []).length
        return `${n} request${n === 1 ? '' : 's'} from customers, partners, and community.`
      }
    },
    Content: {
      padding: 'B B1',
      maxWidth: 'L+L',
      width: '100%',
      margin: '0 auto',
      ..._cardGrid,
      childExtends: 'RequestCard',
      childrenAs: 'state',
      children: (el, s) => s.root.customerRequests || []
    }
  }
}

export const RequestsInboundMain = {
  extends: 'AppMain',
  padding: '0',
  Header: { extends: 'TicketsHeader' },
  Body: {
    overflow: 'auto',
    Hero: {
      extends: 'PageHero',
      eyebrow: 'REQUESTS · INBOUND',
      headline: 'Inbound',
      lede: (el, s) => {
        const n = (s.root.inboundRequests || []).length
        return `${n} incoming request${n === 1 ? '' : 's'} from customers, partners, and prospects.`
      }
    },
    Content: {
      padding: 'B B1',
      maxWidth: 'L+L',
      width: '100%',
      margin: '0 auto',
      ..._cardGrid,
      childExtends: 'RequestCard',
      childrenAs: 'state',
      children: (el, s) => s.root.inboundRequests || []
    }
  }
}

export const RequestsOutboundMain = {
  extends: 'AppMain',
  Header: { extends: 'TicketsHeader' },
  Body: {
    overflow: 'auto',
    Hero: {
      extends: 'PageHero',
      eyebrow: 'REQUESTS · OUTBOUND',
      headline: 'Outbound',
      lede: (el, s) => {
        const n = (s.root.outboundRequests || []).length
        return `${n} outreach item${n === 1 ? '' : 's'} — proposals, follow-ups, and communications.`
      }
    },
    Content: {
      padding: 'B B1',
      maxWidth: 'L+L',
      width: '100%',
      margin: '0 auto',
      ..._cardGrid,
      childExtends: 'RequestCard',
      childrenAs: 'state',
      children: (el, s) => s.root.outboundRequests || []
    }
  }
}

export const RequestsAuditMain = {
  extends: 'AppMain',
  Header: { extends: 'TicketsHeader' },
  Body: {
    overflow: 'auto',
    Hero: {
      extends: 'PageHero',
      eyebrow: 'REQUESTS · AUDIT',
      headline: 'Audit / Reports',
      lede: (el, s) => {
        const n = (s.root.auditReports || []).length
        return `${n} audit${n === 1 ? '' : 's'} and report${n === 1 ? '' : 's'}.`
      }
    },
    Content: {
      padding: 'B B1',
      maxWidth: 'L+L',
      width: '100%',
      margin: '0 auto',
      ..._cardGrid,
      childExtends: 'AuditCard',
      childrenAs: 'state',
      children: (el, s) => s.root.auditReports || []
    }
  }
}
